import { PageHeader } from "../../../../components/page-skeleton/PageHeader";
import { routes } from "../../../../appRoutingHelpers";
import { useGetHomepages } from "../../../../service/api";
import { AppHomepageListHeader } from "./AppHomepageListHeader";
import { Table } from "../../../../components/table-components/Table";
import { AppHomepageListRow } from "./AppHomepageListRow";
import { SpinnerBlock } from "../../../common/Spinner";
import { CardContainer } from "../../../../components/page-skeleton/CardContainer";
import { Placeholder } from "../../../../components/Placeholder";
import { ButtonInternalLink } from "../../../../components/NewButtons";
import { PageFooter } from "../../../../components/page-skeleton/PageFooter";
import { TableBody } from "../../../../components/table-components/TableBody";
import { StyledText } from "../../../../assets/typography/typography";
import { colors } from "../../../../components/colors";
import { useSelector } from "react-redux";
import * as authSelectors from "../../../auth/authSelectors";
import { useHandleFetchError } from "../../../../error-handler";

export const AppHomepageList = () => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );

  const { data: homepages, error: getHomepagesError } = useGetHomepages(
    organizationKeyName
  );

  useHandleFetchError(getHomepagesError);

  if (!homepages) {
    return <SpinnerBlock />;
  }

  return (
    <CardContainer>
      <PageHeader
        title="App homepages list"
        subtitle="Create, manage and edit app homepages."
      >
        <ButtonInternalLink
          to={routes.homepageUpsertListNew(organizationKeyName)}
        >
          Add new
        </ButtonInternalLink>
      </PageHeader>
      <div>
        {homepages.length === 0 ? (
          <Placeholder>
            No homepages created yet! Create your first and display it in the
            app.
          </Placeholder>
        ) : (
          <Table>
            <AppHomepageListHeader />
            <TableBody>
              {homepages?.map((homepage, index) => (
                <AppHomepageListRow key={index} homepage={homepage} />
              ))}
            </TableBody>
          </Table>
        )}
        <PageFooter>
          <StyledText
            className="bodyTextRegular mb-0"
            color={colors.textSecondary}
          >
            {homepages.length} homepages in total
          </StyledText>
        </PageFooter>
      </div>
    </CardContainer>
  );
};
